// Copyright (c) 2020 embyt GmbH. All rights reserved.
// Author: Roman Morawek
//
// this contains all volatile current state variables of connected site

import { IAlarmEntry } from "comtypes";

export interface IStateDataOutput {
  logical: number;
  physical: number;
}

export interface IControlDataRow {
  timestamp: number;
  energy: number;
  isEstimate: boolean;
}

export interface ITariffCircuitData {
  timeOfPeriod: number;
  power: number;
  energy: number;
}

export interface IControlData {
  targetValue: number;
  regulationPriorityStatus: number;
  trendLevel: number;
  values: IControlDataRow[];
}

// keep consistent with chargectl/types.ts
export enum PlugState {
  no_cable,
  cable_in_charger,
  cable_in_charger_and_car,
}

// keep consistent with chargectl/types.ts
export enum ChargingState {
  not_ready,
  available,
  charging,
  charging_paused,
  error,
  charging_paused_by_EV,
}

// this is only used in local controller web interface
export interface IStateDataCharger {
  curP?: number;
  curI?: number[];
  curU?: number[];
  devMaxI?: number;
  setMaxI?: number;
  eTotal?: number;
  eSession?: number;
  plugState?: PlugState;
  plugIsLocked?: boolean;
  chargingState?: ChargingState;
  isConnected: boolean;
  chargerWritePending: boolean;
  errorChargerRW: boolean;
  auth?: string;
  reqMaxPower?: number;
  reqMaxCurrent?: number;
}

export interface IStateData {
  timestamp: number;

  input: number[];
  output: IStateDataOutput[];
  energymeter: number[];
  tariffcircuit: ITariffCircuitData[];
  controlcircuit: IControlData[];
  condition: number[];
  module: boolean[];

  charger?: IStateDataCharger[]; // only used in local controller web interface

  alarms: IAlarmEntry[];
}

/* initial state */
export const INITIAL_STATE: IStateData = {
  timestamp: 0,
  input: [],
  output: [],
  energymeter: [],
  tariffcircuit: [],
  controlcircuit: [],
  condition: [],
  module: [],
  alarms: [],
};
